<template>
  <gj-modal
      notFooterPadding
      size="1300_auto"
      :visible.sync="modalVisible"
      :confirmLoading="confirmLoading"
      @cancel="cancel"
      @confirm="confirm">
    <template #header>新增否定商品投放</template>
    <template #content>
      <el-form
        ref="form"
        :model="form">
        <AppBaseInfo
          ref="base"
          :form="form.baseInfoForm"
          :targetingType="1"
          @campaignChange="campaignChange"
        />
        <AppAutoNegTargetPicker
            ref="picker"
            :form="form.autoTargetPickerForm"
            :marketId="marketId"
            :params="params"
            title="否定商品" 
          />
      </el-form>
    </template>
  </gj-modal>
</template>

<script>
import { adStore } from "modules/ad/common/store";
import AppBaseInfo from "../common/sb-base-info";
import AppAutoNegTargetPicker from "../common/auto-neg-target-picker";
import { isMeaningful } from "@/utils/common";
import { AdCampaignEnum, AdGroupEnum } from "@/views/modules/ad/common/enum";
import { isMeaningfulMixin, isMeaninglessMixin, modalMixIn } from "@/minxins";
import { addSpAdNegTarget, getProductBrand, adsSbNegativeProductTargetingCreate } from "@/api/ad";

export default {
  name: "app-add-sp-ad-neg-target",
  mixins: [modalMixIn, isMeaninglessMixin, isMeaningfulMixin],
  components: {AppAutoNegTargetPicker, AppBaseInfo},
  props: {
    marketId: {
      required: true
    },
    group: {
      required: false,
      default: null
    }
  },
  data() {
    return {
      adStore,
      params: {},
      form: {
        baseInfoForm: {
          campaignId: null,
          groupId: null,
        },
        autoTargetPickerForm: {
          items: []
        }
      },
      AdGroupEnum: AdGroupEnum
    }
  },
  watch: {
  },
  computed: {},
  methods: {
    campaignChange(campaignId) {
      this.params = {campaignId}
      this.$refs.picker.getProductBrand(this.params)
    },
    confirm() {
      const formValid = !['base', 'picker'].some(e => !this.$refs[e].formValidate());
      if (formValid) {
        this.confirmLoading = true;
        const params = {
          marketId: this.marketId,
          targetsBeans: this.form.autoTargetPickerForm.items.map(item => ({
            campaignId: this.form.baseInfoForm.campaignId,
            groupId: this.form.baseInfoForm.groupId,
            expressions: [{
              type: item.asin ? 8 : 1,
              value: item.asin ? item.asin : item.id
            }],
          }))
        };
        adsSbNegativeProductTargetingCreate(params)
          .then(() => {
            this.$gjDestroy();
            this.$emit('created');
          })
          .complete(() => this.confirmLoading = false);
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        if (this.adStore.SB.campaign.campaignId) {
          let campaignId = this.adStore.SB.campaign.campaignId
          this.params = {campaignId}
          this.$refs.picker.getProductBrand(this.params)
        }
      }, 100);
    })
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../../common/common";
  /deep/.gj-picker {
    margin-left: 80px;
  }
  /deep/.el-form-item__label {
    width: 80px;
    text-align: right;
    &::before {
      left: 9px;
    }
  }
</style>
